// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__Kyem7","select":"Header_select__KrJZG","clinic":"Header_clinic__3jICT"};